export default __webpack_public_path__ + "static/media/ios-qrcode.288c1650.png";